module.exports = "<router-outlet></router-outlet>\r\n<!-- <app-utente></app-utente> -->\r\n<!-- <app-login></app-login> -->\r\n\r\n"